import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import moment from "moment";

const DprList = ({ dprItem, index }) => {
  return (
    <tr key={index}>
      <td>{index + 1}</td>
      <td>{moment(dprItem.createdAt).format("DD-MM-YYYY")}</td>
      <td>
        <Link
          to={{
            pathname: `/reports/dpr/dpr-detail/${dprItem._id}`
          }}
        >
          {dprItem?.locationId?.locationName}
        </Link>
      </td>
      <td>{dprItem?.createdBy?.workerId}</td>
      <td>
        {dprItem?.createdBy?.workerFirstName +
          " " +
          dprItem?.createdBy?.workerSurname}
      </td>
    </tr>
  );
};

DprList.propTypes = {
  dprItem: PropTypes.object.isRequired,
  index: PropTypes.any.isRequired
};

export default DprList;
